/* eslint-disable react/state-in-constructor */
import React from 'react';
import _ from 'lodash';
import { FullscreenOutlined } from '@ant-design/icons';
import { Space, Tooltip } from 'antd';
export default function Extra(_ref) {
  var {
    onChange
  } = _ref;
  return /*#__PURE__*/React.createElement(Space, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Fullscreen"
  }, /*#__PURE__*/React.createElement(FullscreenOutlined, {
    onClick: event => {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
      onChange(true);
    }
  })));
}